import React from 'react'
import { Translation } from '@morningtrain/react-translations'
import { ExecuteOperationOnPipe, TriggerPipelineOnFormSubmit } from '@morningtrain/react-resources'
import { Pipeline } from '@morningtrain/react-helpers'
import * as UI from 'ui'

export default function VacationRequestSaveButton ({ create = false }) {
  const saveLabel = create ? 'smartviews.vacation_request.request' : 'generic.save'

  return (
    <UI.ButtonWrap>
      <UI.SubmitButton>
        <Translation name={saveLabel}/>
      </UI.SubmitButton>

      <Pipeline>
        <TriggerPipelineOnFormSubmit/>
        <ExecuteOperationOnPipe resourceName='vacation.vacation_requests' operationName='my_requests'/>
      </Pipeline>
    </UI.ButtonWrap>
  )
}